import { BuildingOffice2Icon } from '@heroicons/react/24/outline';
import type { ToolManifest } from '../types';

const manifest: ToolManifest = {
  slug: 'nace-araci',
  href: '/araclar/nace-araci',
  title: 'NACE Kodu Sorgulama',
  shortLabel: 'NACE',
  eyebrow: '33211 sayılı 2026 tebliği',
  description:
    'NACE kodu, kısmi kod veya faaliyet adı ile tehlike sınıfını sorgulayın. Gerekli iş güvenliği uzmanı sınıfı (A/B/C), risk analizi yenileme, tatbikat ve eğitim periyotları otomatik hesaplanır.',
  bullets: [
    '6 haneli kod arama + faaliyet adı',
    'Çalışan sayısına göre İSG kurulu / temsilci',
    'İlgili faaliyet kodu önerileri',
    'PDF rapor (mevzuat referanslı çıktı)',
  ],
  audience: 'OSGB · iş güvenliği uzmanı · Yeni iş kuran girişimci',
  icon: BuildingOffice2Icon,
  mevzuat: [
    { no: '33211', ad: 'İşyeri Tehlike Sınıfları Tebliği Değişikliği (2026)' },
    { no: '28509', ad: 'İşyeri Tehlike Sınıfları Tebliği (taban)' },
    { no: '6331', ad: 'İş Sağlığı ve Güvenliği Kanunu' },
  ],
  imzaTipi: 'YOK',
  raporlama: 'PDF',
  pdfEndpoint: '/api/nace/pdf',
  faqs: [
    {
      question: 'NACE kodu nedir?',
      answer:
        "NACE (Nomenclature statistique des Activités économiques dans la Communauté Européenne) kodu, işyerinizin faaliyet alanını sınıflandıran 6 haneli koddur (XX.XX.XX formatında). Türkiye'de NACE Rev.2 sistemi kullanılır. İş Sağlığı ve Güvenliğine İlişkin İşyeri Tehlike Sınıfları Tebliği (Resmî Gazete 28509, 26.12.2012; son değişiklik Resmî Gazete 33211, 01.04.2026) gereği, bu kod işyerinizin az tehlikeli, tehlikeli veya çok tehlikeli sınıfta olduğunu belirler.",
    },
    {
      question: "2026'da NACE kodumun tehlike sınıfı değişti mi?",
      answer:
        "1 Nisan 2026 tarihli ve 33211 sayılı Resmî Gazete'de yayımlanan değişiklik tebliği ile birçok NACE kodunun tehlike sınıfı güncellenmiştir. Madencilik, kimya, imalat ve teknik servis sektörleri başta olmak üzere bazı kodlar yeniden sınıflandırılmıştır. Tehlike sınıfı yükselen işyerlerinde gerekli iş güvenliği uzmanı sınıfı (örneğin Tehlikeli → Çok Tehlikeli geçişinde A sınıfı uzman) ve hizmet süreleri de değişir.",
    },
    {
      question: 'Hangi tehlike sınıfında hangi sınıf iş güvenliği uzmanı gerekir?',
      answer:
        'İş Güvenliği Uzmanlarının Görev, Yetki, Sorumluluk ve Eğitimleri Hakkında Yönetmelik Md 7 (Resmî Gazete 28512, 29.12.2012) uyarınca: Az Tehlikeli sınıfta en az C sınıfı uzman yeterlidir. Tehlikeli sınıfta en az B sınıfı uzman gerekir; C sınıfı yetmez. Çok Tehlikeli sınıfta A sınıfı uzman zorunludur.',
    },
    {
      question: 'Aramada NACE kodunun bir kısmını yazabilir miyim?',
      answer:
        'Evet. Tek arama kutusu hem kod hem faaliyet için çalışır. Örnek: "47.11" yazarak 47.11 ile başlayan tüm 6 haneli kodları, "4711" yazarak aynı listeyi (noktasız) listeleyebilirsiniz. "ekmek" yazarak faaliyet adında geçen tüm kodlar görünür.',
    },
    {
      question: 'Yanlış NACE kodu seçersem ne olur?',
      answer:
        'Yanlış NACE kodu yanlış tehlike sınıfı değerlendirmesine ve yanlış iş güvenliği uzmanı saatine, eksik veya fazla SGK prim ödemesine, Bakanlık denetiminde idari para cezasına yol açabilir. Faaliyetiniz değişmişse NACE kodu güncellenmesi SGK üzerinden yapılmalıdır.',
    },
    {
      question: 'Bu araç tehlike sınıfından hangi yükümlülükleri çıkarır?',
      answer:
        'Kodu seçtiğinizde araç, tehlike sınıfına göre şu yükümlülükleri mevzuat maddesiyle birlikte gösterir: gerekli iş güvenliği uzmanı sınıfı (Az Tehlikeli’de A/B/C, Tehlikeli’de en az B, Çok Tehlikeli’de A), risk değerlendirmesi yenileme periyodu (6/4/2 yıl), acil durum tatbikatı (tüm sınıflarda yılda en az 1), işe başlama eğitimi (en az 2 saat, yüz yüze), temel İSG eğitimi süresi (8/12/16 ders saati) ve tekrar eğitimi periyodu (3/2/1 yılda bir, en az 8 ders saati).',
    },
    {
      question: 'NACE aracı çalışan sayısına göre ne hesaplar?',
      answer:
        'Çalışan sayısı kutusunu doldurduğunuzda araç, İSG kurulu zorunluluğunu (50 ve üzeri çalışan + 6 aydan uzun sürekli iş) ve kurul kurulması gerekiyorsa toplantı sıklığını gösterir. Kurul ayda en az bir toplanır; kurul, tehlike sınıfını dikkate alarak bu aralığı tehlikeli işyerinde en geç 2 aya, az tehlikeli işyerinde en geç 3 aya çıkarabilir (çok tehlikelide aylık zorunluluk uzatılamaz — 28532 sayılı Yön. Md 9). Ayrıca çalışan temsilcisi sayısını (2 çalışandan itibaren 1, 2001 ve üzerinde 6’ya kadar) hesaplar. İş güvenliği uzmanı ve işyeri hekimi aylık hizmet süreleri için Yasal Yükümlülük Hesaplayıcı kullanılır.',
    },
    {
      question: 'Eski veya mülga NACE kodumu aratınca ne olur?',
      answer:
        '01.04.2026 tarihli 33211 sayılı tebliğle numarası değişen bir kodun eski (mülga) hâlini aratırsanız, araç sizi güncel koda yönlendirir. SGK sicilinizde hâlâ eski kod görünebilir; aracın gösterdiği güncel kodu muhasebeciniz aracılığıyla e-Devlet üzerinden güncelleyebilirsiniz. Ayrıca 2026 tebliğinden etkilenen kodlar (yeni eklenen, tehlike sınıfı/tanımı veya numarası değişen) sonuç ekranında özel bir rozetle işaretlenir.',
    },
  ],
  seo: {
    // 2026-09-30: 'tehlike sınıfı sorgulama' ailesi 3.3→6.4 kaydı (GSC); rakip başlıklar birebir-eşleşme.
    // NACE başta kalır (Copilot atıf lideri 'nace kodu'), tehlike sınıfı sorgulama birebir eklenir. ≤60 karakter.
    title: 'NACE Kodu ve Tehlike Sınıfı Sorgulama 2026 | Riskmatik',
    description:
      'NACE kodu ile tehlike sınıfı sorgulama (28509 sayılı Tebliğ, 33211 ile 2026 güncellemesi): uzman sınıfı (A/B/C), risk analizi ve eğitim periyotları, PDF rapor.',
    keywords:
      'nace kodu sorgulama, nace kodu nedir, nace kodu, nace kodu tehlike sınıfı sorgulama, işyeri tehlike sınıfı sorgulama, nace 2026, 33211 sayılı tebliğ, tehlike sınıfı, isg uzmanı sınıfı, risk analizi periyodu, sgk nace kodu',
    canonicalPath: '/araclar/nace-araci',
    lastmod: '2026-10-18',
    priority: '0.9',
    changefreq: 'monthly',
    featureList: [
      'NACE kodu (6 haneli) veya faaliyet adıyla anında arama — noktalı/noktasız ve kısmi kod desteği, klavye ile gezinme',
      'İşyeri tehlike sınıfını gösterir: Az Tehlikeli, Tehlikeli veya Çok Tehlikeli (33211 sayılı 2026 tebliği)',
      '01.04.2026 tarihli 33211 sayılı tebliğ değişikliklerini işaretler: tehlike sınıfı değişen, numarası değişen ve yeni eklenen kodlar',
      'Eski (mülga) NACE kodunu aratınca 2026 tebliğiyle gelen güncel koda otomatik yönlendirir',
      'Gerekli iş güvenliği uzmanı sınıfını belirtir: Az Tehlikeli A/B/C, Tehlikeli en az B, Çok Tehlikeli A (İş Güvenliği Uzmanları Yön. Md 7)',
      'Risk değerlendirmesi yenileme periyodunu gösterir: Az Tehlikeli 6, Tehlikeli 4, Çok Tehlikeli 2 yıl (28512 Md 12)',
      'Acil durum tatbikatı sıklığını gösterir: tüm sınıflarda yılda en az 1 (28681 Md 13)',
      'İşe başlama, temel (8/12/16 ders saati) ve tekrar (3/2/1 yıl) İSG eğitimi süre ve periyotlarını mevzuat referansıyla listeler',
      'Çalışan sayısına göre İSG kurulu zorunluluğu (50+) ve tehlike sınıfına göre kurul toplantı sıklığını hesaplar',
      'Çalışan sayısına göre çalışan temsilcisi sayısını hesaplar (28750 Md 7)',
      'Aynı sektör grubundaki ilgili faaliyet kodlarını önerir',
      'Tüm yükümlülükleri mevzuat referanslı PDF rapor olarak görüntüler veya indirir',
      'Yasal Yükümlülük Hesaplayıcı’ya tek tıkla geçiş: tehlike sınıfı ve çalışan sayısı taşınır, yıllık eğitim adam-saat planı çıkar',
      '2.100+ güncel NACE Rev.2 detay kodu; tamamen ücretsiz, reklamsız ve kayıt gerektirmez',
    ],
  },
  order: 10,
  enabled: true,
  launchedAt: '2025-12-01',
  topics: ['nace', 'tehlike-sinifi', 'tehlike-sınıfı', '33211', 'sektor', 'kod-sorgulama', 'isyeri-tehlike', 'cok-tehlikeli', 'tehlikeli', 'az-tehlikeli', 'nace-kodu', 'firma-tehlike-sinifi'],
  intent: 'sorgu',
  spamCapacity: 6,
  bridge: {
    href: '/ai-destekli-risk-analizi',
    etiket: 'Bu tehlike sınıfı için yapay zeka destekli risk analizini görün',
  },
};

export default manifest;
